// Same caps the backend applies before redirecting a rejection here (auth_router.py).
const MAX_ERROR_LENGTH = 64;
const MAX_DESCRIPTION_LENGTH = 500;

// Control, format (including bidi overrides), private-use and unassigned characters,
// plus line and paragraph separators.
const UNSAFE_CHARACTERS = /[\p{C}\p{Zl}\p{Zp}]+/gu;

function clean(value: string | null, maxLength: number): string {
    const text = (value ?? "").replace(UNSAFE_CHARACTERS, " ").replace(/\s+/g, " ").trim();
    const characters = Array.from(text);
    return characters.length > maxLength ? `${characters.slice(0, maxLength - 1).join("")}…` : text;
}

/**
 * The /login message for `error=idp_rejected`: the IdP's own error and description, quoted.
 *
 * The text arrives in the URL, so anyone can craft it: it is cleaned, capped, attributed
 * to the IdP, and must only ever be rendered as plain text. Our own sentences stay neutral,
 * because `access_denied` from Google or GitHub usually means the user cancelled.
 */
export function idpRejectionMessage(search: string): string {
    const params = new URLSearchParams(search);
    const error = clean(params.get("idp_error"), MAX_ERROR_LENGTH);
    const description = clean(params.get("idp_error_description"), MAX_DESCRIPTION_LENGTH);
    const response = [error, description].filter(Boolean).join(": ");
    const quoted = response ? ` It said: "${response}"` : "";
    return `Your identity provider did not complete the sign-in.${quoted} If you should have access to Oplane, ask your IT administrator.`;
}
